module.exports = __webpack_public_path__ + "img/Corporate social responsibility Icon - charcoal.f9a043eb.svg";